import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './pagination.module.scss';
import useWindowDimensions from '../../hooks/useWindowDimensions';

function Pagination({
  currentPage,
  totalPages = 10,
  handlePageChange = () => {},
}) {
  const { width } = useWindowDimensions();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (width < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width]);

  const previousLabel = !isMobile ? 'Previous' : '';
  const nextLabel = !isMobile ? 'Next' : '';

  return (
    totalPages > 1 && (
      <ul className={styles.pagination}>
        {currentPage > 1 && (
          <li
            onClick={() => handlePageChange(currentPage - 1)}
            aria-hidden="true"
            type="button"
            className={`${styles.pageItem} ${styles.firstItem}`}
          >
            <a className={styles.pageLink}>{previousLabel}</a>
          </li>
        )}
        {(() => {
          let dots = false;
          return Array.from({ length: totalPages }, (_, i) => {
            if (
              i < 3 ||
              i > totalPages - 4 ||
              [currentPage - 2, currentPage - 1, currentPage].includes(i)
            ) {
              dots = false;
              return (
                <li
                  key={i + 1}
                  onClick={() => handlePageChange(i + 1)}
                  aria-hidden="true"
                  type="button"
                  className={`${currentPage === i + 1 ? styles.active : ''} ${
                    styles.pageItem
                  }`}
                >
                  <a
                    {...(currentPage === i + 2 && { rel: 'prev' })}
                    {...(currentPage === i && { rel: 'next' })}
                    className={styles.pageLink}
                  >
                    {i + 1}
                  </a>
                </li>
              );
            }
            if (!dots) {
              dots = true;
              return (
                <li
                  key={i + 1}
                  aria-hidden="true"
                  type="button"
                  className={`${styles.disabled} ${styles.pageItem}`}
                >
                  <a className={styles.pageLink}>...</a>
                </li>
              );
            }
            return null;
          });
        })()}
        {currentPage < totalPages && (
          <li
            onClick={() => handlePageChange(currentPage + 1)}
            aria-hidden="true"
            type="button"
            className={`${styles.pageItem} ${styles.lastItem}`}
          >
            <a className={styles.pageLink}>{nextLabel}</a>
          </li>
        )}
      </ul>
    )
  );
}

Pagination.propTypes = {
  totalPages: PropTypes.number,
  handlePageChange: PropTypes.func,
};

export default Pagination;
